import { useFormikContext } from "formik";
import ReactLoading from 'react-loading';

interface iValidatedButtonProps{
    loading?:boolean
    children: JSX.Element | JSX.Element[]
}

interface iValidatedPrimaryButtonProps{
    children:JSX.Element|JSX.Element[]|string
    disabled?:boolean
    loading:boolean
}

interface iValidatedBorderButtonProps{
    children: JSX.Element | JSX.Element[]
    color?: string
    loading?: boolean
}

export default function ValidatedButton({loading, children}:iValidatedButtonProps){

    const {handleSubmit} = useFormikContext<any>()

    return(

        <div
            className="py-2 px-4 rounded text-primary capitalize cursor-pointer no-underline flex justify-center items-center w-full"
            onClick={()=>handleSubmit()}
        >
            {loading ? children : <ReactLoading type="spin" height={20} width={20} color="#fff" />}
        </div>

    )

}

export function ValidatedPrimaryButton({children, disabled=false, loading}:iValidatedPrimaryButtonProps){

    const {handleSubmit} = useFormikContext()

    return(

        <button
            type="submit"
            className="py-2 px-4 rounded capitalize cursor-pointer no-underline flex justify-center items-center w-full   text-light_col bg-primary border border-solid border-primary duration-300 disabled:bg-slate-500"
            onClick={()=>handleSubmit()}
            disabled={disabled}
        >
            {loading ? <ReactLoading type="spin" height={20} width={20} color="#fff" /> : children}
        </button>

    )

}

export function ValidatedAccentButton({children, loading}:iValidatedButtonProps){

    const {handleSubmit} = useFormikContext()

    return(

        <div
            className="py-2 px-4 rounded text-primary capitalize cursor-pointer no-underline flex justify-center items-center w-full    bg-secondary border border-solid border-secondary duration-300"
            onClick={()=>handleSubmit()}
        >
            {loading ? children : <ReactLoading type="spin" height={20} width={20} color="#fff" />}
        </div>

    )

}


export function ValidatedBorderButton({children, color, loading}:iValidatedBorderButtonProps){

    const {handleSubmit} = useFormikContext()

    return(

        <div
            className="py-2 px-4 rounded capitalize cursor-pointer no-underline flex justify-center items-center w-full  text-secondary2 border border-solid border-secondary2 duration-300"
            onClick={()=>handleSubmit()}
        >
            {loading ? children : <ReactLoading type="spin" height={20} width={20} color="#fff" />}
        </div>

    )

}

